<template>
  <b-container fluid>
    <b-row class="p-0 m-0 px-5">
      <b-col lg="12" class="m-0 p-4 right-out">
        <!-- Back -->
        <b-row class="p-0 m-0">
          <b-col @click="goBack()" lg="12" class="m-0 p-0 pt-1 text-left">
            <svg width="24" style="cursor:pointer" height="25" viewBox="0 0 24 25" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9.90906 7.76521C9.50324 7.3906 8.87058 7.4159 8.49597 7.82172L5.2652 11.3217C4.9116 11.7047 4.9116 12.2952 5.26519 12.6782L8.49597 16.1783C8.87057 16.5841 9.50323 16.6094 9.90905 16.2348C10.3149 15.8602 10.3402 15.2276 9.96558 14.8217L8.28397 13L18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11L8.284 11L9.96557 9.17829C10.3402 8.77247 10.3149 8.13981 9.90906 7.76521Z"
                fill="#777E91" />
            </svg>
          </b-col>
        </b-row>

        <!-- Header -->
        <div class="d-flex align-items-start justify-content-between mt-2 mb-3">
          <div>
            <h4 class="mb-1 text-light">Мои транзакции</h4>
            <div class="text-muted small">
              Всего: <span class="text-light">{{ transactions.length }}</span>
              <span class="mx-2">•</span>
              <span v-if="lastUpdated" class="text-muted">Обновлено: {{ lastUpdated }}</span>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-button
              variant="outline-light"
              class="refresh-btn"
              :disabled="loading"
              @click="fetchTransactions(true)"
            >
              <b-spinner small v-if="loading" class="mr-2"></b-spinner>
              <span v-else class="mr-2">↻</span>
              Обновить
            </b-button>
          </div>
        </div>

        <!-- Error -->
        <b-alert v-if="error" show variant="danger" class="mb-3">
          {{ error }}
        </b-alert>

        <!-- Loading skeleton -->
        <div v-if="loading && transactions.length === 0">
          <div class="skeleton mb-2" v-for="i in 4" :key="i"></div>
        </div>

        <!-- Empty -->
        <div v-else-if="!loading && transactions.length === 0" class="empty-state">
          <div class="empty-icon">🧾</div>
          <div class="text-light font-weight-bold mb-1">Пока нет транзакций</div>
          <div class="text-muted small mb-3">Нажмите «Обновить», чтобы проверить снова.</div>
          <b-button variant="primary" @click="fetchTransactions(true)">Обновить</b-button>
        </div>

        <!-- List -->
        <div v-else class="tx-list">
          <b-row class="m-0">
            <b-col
              cols="12"
              class="p-0"
              v-for="tx in transactions"
              :key="tx.transactionId"
            >
              <div class="tx-card">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <div class="d-flex align-items-center flex-wrap">
                      <div class="tx-title mr-2">
                        Транзакция #{{ tx.transactionId }}
                      </div>
                      <b-badge :variant="statusVariant(tx.txStatus)" class="tx-badge">
                        {{ tx.txStatus }}
                      </b-badge>
                    </div>

                    <div class="tx-meta mt-2">
                      <span class="meta-chip">
                        <span class="meta-label">Валюта:</span> {{ tx.currency }}
                      </span>
                      <span class="meta-chip">
                        <span class="meta-label">User:</span> {{ loginedUser.userName }}
                      </span>
                      <!-- <span class="meta-chip">
                        <span class="meta-label">Bank:</span> {{ tx.bankId }}
                      </span> -->
                    </div>

                    <div class="tx-bank mt-2" v-if="tx.bankRef">
                      <div class="text-muted small">
                        <span class="text-light">{{ tx.bankRef.bankName }}</span>
                        • {{ tx.bankRef.accountName }}
                      </div>
                      <div class="text-muted small">
                        IBAN: <span class="text-light">{{ tx.bankRef.iban }}</span>
                        <span class="mx-2">•</span>
                        BIN: <span class="text-light">{{ tx.bankRef.bin }}</span>
                        <span class="mx-2">•</span>
                        BIK: <span class="text-light">{{ tx.bankRef.bik }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="text-right">
                    <div class="tx-amount">
                      {{ formatAmount(tx.amount, tx.currency) }}
                    </div>
                    <div class="text-muted small">
                      ID: {{ tx.bankId }} / Ref: {{ tx.bankRef && tx.bankRef.bankId }}
                    </div>
                  </div>
                </div>
              </div>

            </b-col>
          </b-row>
        </div>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import { apiDomain, getHeader } from "@/config/config";
import { EventBus } from "@/EventBus";
import { mapState } from "vuex";
export default {
  name: "UserTransaction",
  data() {
    return {
      transactions: [],
      loading: false,
      error: "",
      lastUpdated: ""
    };
  },
  methods: {
    goBack() {
      // if you already have router:
      if (this.$router) this.$router.back();
    },

    async fetchTransactions(isManual = false) {
      if (this.loading) return;

      this.loading = true;
      this.error = "";

      try {
        const res = await axios.get(apiDomain + "/exchange/transaction/list", {
          headers: getHeader(),
        });

        // if backend returns array
        this.transactions = Array.isArray(res.data) ? res.data : [];
        this.lastUpdated = new Date().toLocaleString();

        // notify landing to refresh user details (limit, status, etc.) on manual refresh
        if (isManual) {
          EventBus.$emit("refresh-user-details");
        }
      } catch (e) {
        console.error("There was an error fetching the transactions!", e);
        this.error = "Не удалось загрузить транзакции. Проверьте интернет или попробуйте позже.";
        if (!isManual) {
          // keep silent on first load if you want; but we show error anyway
        }
      } finally {
        this.loading = false;
      }
    },

    statusVariant(status) {
      const s = (status || "").toUpperCase();
      if (s === "SUCCESS" || s === "COMPLETED") return "success";
      if (s === "PENDING") return "warning";
      if (s === "FAILED" || s === "REJECTED") return "danger";
      return "secondary";
    },

    formatAmount(amount, currency) {
      // KZT usually no decimals
      const n = Number(amount || 0);
      const isKzt = (currency || "").toUpperCase() === "KZT";
      return new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: isKzt ? 0 : 2,
        maximumFractionDigits: isKzt ? 0 : 2
      }).format(n) + " " + (currency || "");
    }
  },
    created() {
        this.fetchTransactions(false);
    },
    computed:{
        ...mapState([
            'loginedUser'
        ]),
        
    },
};
</script>

<style scoped>
.right-out{
  border-radius: 16px;
  background: var(--Shade-2-30, #18191D);
  box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.10);
}

.refresh-btn{
  border-radius: 12px;
  padding: 8px 14px;
}

.tx-list{
  margin-top: 10px;
}

.tx-card{
  border-radius: 16px;
  background: rgba(35, 38, 47, 0.55);
  border: 1px solid rgba(53, 57, 69, 0.9);
  padding: 16px;
  margin-bottom: 12px;
  transition: transform .12s ease, background .12s ease, border-color .12s ease;
}

.tx-card:hover{
  transform: translateY(-1px);
  background: rgba(35, 38, 47, 0.85);
  border-color: rgba(177, 181, 195, 0.25);
}

.tx-title{
  color: #FCFCFD;
  font-weight: 700;
  font-size: 16px;
}

.tx-badge{
  border-radius: 999px;
  padding: 6px 10px;
  font-weight: 700;
  letter-spacing: .2px;
}

.tx-amount{
  color: #FCFCFD;
  font-weight: 800;
  font-size: 18px;
}

.tx-meta{
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.meta-chip{
  border-radius: 999px;
  border: 1px solid rgba(119, 126, 144, 0.45);
  background: rgba(24, 25, 29, 0.35);
  padding: 6px 10px;
  color: #E6E8EC;
  font-size: 12px;
}

.meta-label{
  color: #B1B5C3;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 10px;
  margin-right: 6px;
}

.empty-state{
  border-radius: 16px;
  border: 1px dashed rgba(177, 181, 195, 0.35);
  background: rgba(24, 25, 29, 0.35);
  padding: 28px;
  text-align: center;
}

.empty-icon{
  font-size: 34px;
  margin-bottom: 10px;
}

.skeleton{
  height: 78px;
  border-radius: 16px;
  background: linear-gradient(90deg, rgba(35,38,47,.35), rgba(35,38,47,.65), rgba(35,38,47,.35));
  background-size: 200% 100%;
  animation: shimmer 1.1s infinite linear;
  border: 1px solid rgba(53,57,69,.75);
}

@keyframes shimmer{
  0% { background-position: 0% 0; }
  100% { background-position: -200% 0; }
}
</style>
